<template>
    <table class="table table-hover table-striped dataTable no-footer" width="100%" ref="generalDataTable">
      <thead>
      <tr>
        <th
          v-for="(field, i) in tableColumns"
          :key="i"
          :class="field.className"
        >
        </th>
      </tr>
      </thead>
    </table>
</template>

<script>
import Vue from 'vue'
import Router from 'vue-router'
import $ from 'jquery'
import 'datatables.net-bs/css/dataTables.bootstrap.css'

Vue.use(Router)

export default {
  props: {
    tableData: {
      type: Array,
      required: true
    },
    tableConfiguration: {
      type: Object,
      default: function () {
        return {}
      },
      required: true
    },
    tableColumns: {
      type: Array,
      required: true
    }
  },
  data: () => {
    return {
      dtHandle: null
    }
  },
  watch: {
    tableData () {
      this.dtHandle
        .clear()
        .rows.add(this.tableData)
        .draw()
    }
  },
  methods: {
    constructDataTable () {
      require('datatables.net-bs')
      require('datatables.net-buttons-bs')
      require('datatables.net-buttons/js/buttons.html5')
      require('datatables.net-buttons/js/buttons.print')
      this.dtHandle = $(this.$refs.generalDataTable).DataTable({
        sDom: '<"row"<"col-md-6 text-left"f><"col-md-6 datatable-custom-buttons">>rt<"pull-right"p>li',
        columns: this.tableColumns,
        data: this.tableData,
        destroy: true,
        language: {
          'sProcessing': this.$t('data_table.sProcessing'),
          'sSearch': this.$t('data_table.sSearch'),
          'sLengthMenu': this.$t('data_table.sLengthMenu'),
          'sInfo': this.$t('data_table.sInfo'),
          'sInfoEmpty': this.$t('data_table.sInfoEmpty'),
          'sInfoFiltered': '',
          'sInfoPostFix': '',
          'sLoadingRecords': this.$t('data_table.sLoadingRecords'),
          'sZeroRecords': this.$t('data_table.sZeroRecords'),
          'sEmptyTable': this.$t('data_table.sEmptyTable'),
          'oPaginate': {
            'sFirst': this.$t('data_table.oPaginate.sFirst'),
            'sPrevious': this.$t('data_table.oPaginate.sPrevious'),
            'sNext': this.$t('data_table.oPaginate.sNext'),
            'sLast': this.$t('data_table.oPaginate.sLast')
          },
          'oAria': {
            'sSortAscending': this.$t('data_table.oAria.sSortAscending'),
            'sSortDescending': this.$t('data_table.oAria.sSortDescending')
          },
          'select': {
            'rows': {
              _: this.$t('data_table.select.rows._'),
              0: this.$t('data_table.select.rows.0'),
              1: this.$t('data_table.select.rows.1')
            }
          }
        }
      })
      this.addExportsButton()
    },
    addExportsButton () {
      // eslint-disable-next-line no-new
      new $.fn.dataTable.Buttons(this.dtHandle, {
        dom: {
          buttonLiner: {
            tag: null,
            className: null
          }
        },
        buttons: [
          {
            extend: 'csvHtml5',
            charset: 'utf-8',
            fieldSeparator: ';',
            fieldBoundary: '"',
            bom: true,
            text: '<i class="fa fa-download"></i>',
            titleAttr: this.$t('general.export'),
            attr: {
              'data-toggle': 'tooltip'
            },
            exportOptions: {
              columns: ':not(.not-exportable):visible',
              search: 'applied',
              order: 'applied',
              orthogonal: 'export'
            }
          },
          {
            extend: 'print',
            text: '<i class="fa fa-print"></i>',
            titleAttr: this.$t('general.print'),
            orientation: 'landscape',
            attr: {
              'data-toggle': 'tooltip'
            },
            exportOptions: {
              columns: ':not(.not-exportable):visible',
              search: 'applied',
              order: 'applied',
              orthogonal: 'export'
            }
          }
        ]
      })
      this.dtHandle.buttons().container().appendTo('.datatable-custom-buttons')
    }
  },
  mounted () {
    if (this.dtHandle === null) {
      this.constructDataTable()
    }
  }
}
</script>
